import React from 'react';
import { Phone, MessageCircle, Clock, CreditCard, Calendar, CheckCircle, FileText } from 'lucide-react';
import { MetricCard } from '../ui/MetricCard';
import { SectionHeader } from '../ui/SectionHeader';
import { loanOfficers, companyTotals } from '../data/mockData';
export function ActivitySection() {
  // Helper to find max value in a category to highlight top performer
  const getMax = (key: keyof (typeof loanOfficers)[0]['activity']) => {
    return Math.max(...loanOfficers.map(lo => typeof lo.activity[key] === 'number' ? lo.activity[key] as number : 0));
  };
  const maxDials = getMax('dials');
  const maxConvos = getMax('conversations');
  const maxPulls = getMax('creditPulls');
  const maxApps = getMax('appointments');
  const maxFollowUps = getMax('followUps');
  const maxDocs = getMax('docsCollected');
  return <section className="space-y-6 animate-in fade-in duration-500" data-id="element-19">
      <SectionHeader title="Activity (Effort)" description="Tracking daily inputs and operational discipline." data-id="element-20" />

      {/* KPI Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4" data-id="element-21">
        <MetricCard title="Dials" value={companyTotals.activity.dials.toLocaleString()} icon={Phone} color="blue" data-id="element-22" />
        <MetricCard title="Conversations" value={companyTotals.activity.conversations.toLocaleString()} icon={MessageCircle} data-id="element-23" />
        <MetricCard title="Talk Time" value={`${companyTotals.activity.talkTimeHours}h`} icon={Clock} data-id="element-24" />
        <MetricCard title="Credit Pulls" value={companyTotals.activity.creditPulls} icon={CreditCard} data-id="element-25" />
        <MetricCard title="Appointments" value={companyTotals.activity.appointments} icon={Calendar} data-id="element-26" />
        <MetricCard title="Follow-ups" value={companyTotals.activity.followUps.toLocaleString()} icon={CheckCircle} data-id="element-27" />
        <MetricCard title="Docs Collected" value={companyTotals.activity.docsCollected} icon={FileText} data-id="element-28" />
      </div>

      {/* Detailed Table */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-29">
        <div className="overflow-x-auto" data-id="element-30">
          <table className="w-full text-sm text-left" data-id="element-31">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-32">
              <tr data-id="element-33">
                <th className="px-6 py-4" data-id="element-34">Loan Officer</th>
                <th className="px-6 py-4 text-right" data-id="element-35">Dials</th>
                <th className="px-6 py-4 text-right" data-id="element-36">Conversations</th>
                <th className="px-6 py-4 text-right" data-id="element-37">Talk Time</th>
                <th className="px-6 py-4 text-right" data-id="element-38">Credit Pulls</th>
                <th className="px-6 py-4 text-right" data-id="element-39">Appointments</th>
                <th className="px-6 py-4 text-right" data-id="element-40">Follow-ups</th>
                <th className="px-6 py-4 text-right" data-id="element-41">Docs Collected</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-42">
              {loanOfficers.map(lo => <tr key={lo.id} className="hover:bg-slate-50 transition-colors" data-id="element-43">
                  <td className="px-6 py-4 font-medium text-slate-900 flex items-center gap-3" data-id="element-44">
                    <div className="h-8 w-8 rounded-full bg-[#0F2044] text-white flex items-center justify-center text-xs" data-id="element-45">
                      {lo.avatar}
                    </div>
                    {lo.name}
                  </td>
                  <td className={`px-6 py-4 text-right ${lo.activity.dials === maxDials ? 'text-green-600 font-bold' : 'text-slate-600'}`} data-id="element-46">
                    {lo.activity.dials.toLocaleString()}
                  </td>
                  <td className={`px-6 py-4 text-right ${lo.activity.conversations === maxConvos ? 'text-green-600 font-bold' : 'text-slate-600'}`} data-id="element-47">
                    {lo.activity.conversations.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right text-slate-600" data-id="element-48">
                    {lo.activity.talkTime}
                  </td>
                  <td className={`px-6 py-4 text-right ${lo.activity.creditPulls === maxPulls ? 'text-green-600 font-bold' : 'text-slate-600'}`} data-id="element-49">
                    {lo.activity.creditPulls}
                  </td>
                  <td className={`px-6 py-4 text-right ${lo.activity.appointments === maxApps ? 'text-green-600 font-bold' : 'text-slate-600'}`} data-id="element-50">
                    {lo.activity.appointments}
                  </td>
                  <td className={`px-6 py-4 text-right ${lo.activity.followUps === maxFollowUps ? 'text-green-600 font-bold' : 'text-slate-600'}`} data-id="element-51">
                    {lo.activity.followUps}
                  </td>
                  <td className={`px-6 py-4 text-right ${lo.activity.docsCollected === maxDocs ? 'text-green-600 font-bold' : 'text-slate-600'}`} data-id="element-52">
                    {lo.activity.docsCollected}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}